<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<rect
		x="5"
		y="11"
		width="14"
		height="9"
		stroke="currentColor"
		stroke-width="2"
		stroke-linejoin="round"
	/>
	<rect
		x="4"
		y="7"
		width="16"
		height="4"
		stroke="currentColor"
		stroke-width="2"
		stroke-linejoin="round"
	/>
	<line x1="12" y1="21" x2="12" y2="7" stroke="currentColor" stroke-width="2" />
	<path
		d="M13.3014 2.32358C14.1889 1.2659 15.7658 1.12794 16.8235 2.01544C17.8811 2.90295 18.0191 4.47984 17.1316 5.53752C16.9864 5.71053 16.6368 5.94365 16.0344 6.18187C15.4629 6.40784 14.7823 6.59343 14.1099 6.74041C13.5723 6.85792 13.0563 6.94728 12.6307 7.01214C12.6207 6.58175 12.6191 6.05806 12.6415 5.50825C12.6695 4.82056 12.734 4.11801 12.8573 3.516C12.9873 2.88137 13.1562 2.49659 13.3014 2.32358Z"
		stroke="currentColor"
		stroke-width="2"
	/>
	<path
		d="M7.01586 5.53801C6.12836 4.48033 6.26632 2.90344 7.324 2.01593C8.38169 1.12843 9.95858 1.26639 10.8461 2.32407C10.9913 2.49708 11.1601 2.88186 11.2901 3.51649C11.4134 4.1185 11.478 4.82105 11.506 5.50874C11.5284 6.05855 11.5268 6.58224 11.5167 7.01263C11.0911 6.94777 10.5751 6.85841 10.0376 6.7409C9.36517 6.59392 8.68451 6.40833 8.11305 6.18236C7.51064 5.94414 7.16103 5.71102 7.01586 5.53801Z"
		stroke="currentColor"
		stroke-width="2"
	/>
</svg>
